import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './utils/rem' // 自动设置HTML字体大小
import Vant from 'vant'
import Router from 'vue-router'
import 'vant/lib/index.css'
import filters from './utils/filters'
import { newCommon } from './plugins/directives'
import store from './vuex/index.js'
Vue.use(Vant)
import tools from './utils/tools'
import moment from 'moment'
import * as echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/gauge'
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$tools = tools
Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// import { Integrations } from '@sentry/tracing';
Vue.prototype.newCommon = newCommon
//注册全局api
import api from './request/api'
Vue.prototype.$api = api
// 注册自定义模态框 this.$modal({})
import Modal from '@/components/Modal'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Modal)
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
// Sentry.init({
// 	dsn: 'http://9d5d3a78f1144b0884f91b85bbe15f46@124.156.137.222:9000/23',
// 	integrations: [
// 		new Integrations.BrowserTracing(),
// 		new VueIntegration({
// 			Vue,
// 			tracing: true,
// 			logErrors: true,
// 			attachProps: true,
// 			tracingOptions: {
// 				trackComponents: true,
// 			},
// 		}),
// 	],

// 	release: '1.1.2',
// 	tracesSampleRate: 0.2,
// });
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
